import { ICorrelation } from "../../ViewModel/Utilities";
import { BaseCache, ICacheableItem } from "./BaseCache";


export class PersistentDataCache extends BaseCache<ICacheableItem> {

    constructor(
        storageKey: string,
        config: {
            doReadFN: (id: string) => Promise<any>,
            doWriteFN: (data: ICacheableItem) => Promise<any>,
            doDeleteFN: (id: string) => Promise<void>,
            debugName?: string,
            skipCache: boolean,
            syncExternalChanges?: () => Promise<void>,
            updateVersionOnWrite?: boolean
        }
    ) {
        super(config);
        this._storageKey = storageKey;
        this._derivedType = 'PersistentDataCache';
    }

    /**
     * Clear the cache
     *  
     * @override
     */
    public ClearCache() {
        localStorage.removeItem(this._storageKey);
        this._rawCache.clear();
    }

    public HasCachedItem(_correlation: ICorrelation, id: string): boolean {
        return this._rawCache.has(id);
    }

    public ForEach = (callbackfn: (value: string, index: number, array: string[]) => void, thisArg?: any): void => {
        Array.from(this._rawCache.values()).forEach(callbackfn, thisArg);
    }





    protected GetCacheItem(_correlation: ICorrelation, id: string): ICacheableItem | undefined {
        let rawVal = this._rawCache.get(id);
        let retVal = rawVal ? JSON.parse(rawVal) : undefined;
        return retVal;
    }

    protected SetCacheItem(_correlation: ICorrelation, id: string, item: ICacheableItem) {

        this.DeleteCacheItem(_correlation, id, true);

        let cacheString = '';
        if (item.Serialize)
            cacheString = JSON.stringify(item.Serialize());
        else
            cacheString = JSON.stringify(item);

        this._rawCache.set(id, cacheString);
        this.FlushCache();
    }

    protected DeleteCacheItem(_correlation: ICorrelation, id: string, skipFlush: boolean = false) {
        //
        // Update the in-memory and persisted caches, flush to disk.
        //
        this._rawCache.delete(id);
        if (!skipFlush)
            this.FlushCache();
        // track();
    }

    public FlushCache(rawData?: string) {

        let cacheString = rawData;

        if (!cacheString) {


            let items: { id: string, value: string }[] = [];
            for (let key of this._rawCache.keys()) {
                const id = key;
                items.push({ id: id, value: this._rawCache.get(id)! });
            }
            cacheString = JSON.stringify(items);
        }
        localStorage.setItem(this._storageKey, cacheString);
    }


    public RestoreCache() {

        let itemsString = localStorage.getItem(this._storageKey);
        if (itemsString) {
            let items = JSON.parse(itemsString) as { id: string, value: string }[];
            for (let item of items) {
                this._rawCache.set(item.id, item.value);
            }
        }

        return this._rawCache.size > 0;
    }



    private _storageKey: string;
    private _rawCache = new Map<string, string>();
}